import { GzDashboardMacroComponentWebComponent } from './component/GzDashboardMacroComponentWebComponent';

export { GzDashboardMacroComponentWebComponent };
